import { IBienLaiThuCreateRequest } from "./../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IThuPhiTab } from "./../../../model/request/thu-phi/IThuPhiTab";

import { IMucThuKhacSinhVienSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IBienLaiThuHinhThucNopViewModel } from "../../../model/respone/chung-tu/IBienLaiThuHinhThucNopViewModel";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";
export interface IThuPhiHocSinhTabActionTyes<T> {
  request: IMucThuKhacSinhVienSelectRequest;
  data: T;
}
export interface IThuPhiTabByIdActionTyes<T> {
  id: string;
  data: T;
}

export const eThuPhiActionsObj = {
  ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
  REMOVE_TAB: "",
  UPDATE_TAB_DATA: {} as IThuPhiTab,
  CHANGEG_SELECTED_TAB: "",
  ADD_NEW_TAB_BY_ID: "",
  ADD_NEW_TAB_BY_ID_ERROR: "",
  RENEW_TAB_BY_ID: {} as IThuPhiTabByIdActionTyes<IStuHoSoSinhVienViewModel>,
  LOAD_MUC_THU_KHAC_START: {} as IMucThuKhacSinhVienSelectRequest,
  LOAD_MUC_THU_KHAC_SUCCESS: {} as IThuPhiHocSinhTabActionTyes<
    IMucThuKhacSinhVienViewModel[]
  >,
  LOAD_MUC_THU_KHAC_START_BY_MUCTHUID: [] as number[],
  LOAD_MUC_THU_KHAC_ERROR: {} as IThuPhiHocSinhTabActionTyes<string>,
  CHANGE_MUC_THU_KHAC_SELECTED_IDs: {} as IThuPhiHocSinhTabActionTyes<number[]>,
  CHANGE_STEP: {} as IThuPhiHocSinhTabActionTyes<number>,
  CHANGE_HINHTHUCNOP: {} as IThuPhiHocSinhTabActionTyes<
    IBienLaiThuHinhThucNopViewModel[]
  >,
  CHANGE_MUC_THU_KHAC_SELECTED_IDs_LOP_TIN_CHI:
    {} as IThuPhiHocSinhTabActionTyes<number[]>,
  CHANGE_SO_TIEN_THUC_NOP: {} as IThuPhiHocSinhTabActionTyes<number>,
  CHANGE_DIEU_CHINH_GIAM_DINH_MUC: {} as IThuPhiHocSinhTabActionTyes<boolean>,

  CREATE_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
  CREATE_BIENLAITHU_SUCCESS: {} as IThuPhiHocSinhTabActionTyes<number>,
  CREATE_BIENLAITHU_ERROR: {} as IThuPhiHocSinhTabActionTyes<string>,
  CHANGE_THONGTINBIENLAI: {} as IThuPhiHocSinhTabActionTyes<any>,

  PREVIEW_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
  PREVIEW_BIENLAITHU_SUCCESS: {} as IThuPhiHocSinhTabActionTyes<string>,
  PREVIEW_BIENLAITHU_ERROR: {} as IThuPhiHocSinhTabActionTyes<string>,
  PREVIEW_BIENLAITHU_CLOSE: {} as IThuPhiHocSinhTabActionTyes<string>,

  UPDATE_QRCODE: {} as IThuPhiTabByIdActionTyes<IQRCodeResponse | undefined>,
};
export const eThuPhiActionIds = generateActionTypeIds(
  eThuPhiActionsObj,
  "THU_PHI"
);
export type IThuPhiActionTypes = IGenericActionType<
  typeof eThuPhiActionsObj,
  "THU_PHI"
>;
